import { cva } from 'class-variance-authority'
import { TypographyVariant } from '@ui/typography/types'
import { colors as c } from '@ui/colors'
import { PriceInfoSize } from './types'
import cn from '@ui/utils/cn'

export const sPriceInfo = cva('flex flex-row items-center gap-1 rounded-sm', {
  variants: {
    size: {
      default: 'px-4 py-2',
      small: 'px-3 py-1.5',
    },
    included: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      included: true,
      className: 'bg-white/0',
    },
  ],
  defaultVariants: {
    size: 'default',
    included: false,
  },
})

export const sTextColor = (discount: boolean, included: boolean) => {
  if (included) return c.text25
  if (discount) return c.green[600]
  return c.text
}

export const sBackColor = (discount: boolean, included: boolean) => {
  if (included) return 'bg-white/0'
  if (discount) return 'bg-green-500/10'
  return 'bg-text/5'
}

export const sizeTypography: Record<PriceInfoSize, TypographyVariant> = {
  default: 'MDB',
  small: 'SMB',
}

export const sizeTypographyIncluded: Record<PriceInfoSize, TypographyVariant> =
  {
    default: 'SMB',
    small: 'XSB',
  }

export const sPricePrefix = cn(
  'absolute -top-6 text-center uppercase'
  // leadingNone
)

export const sPriceSuffix = cn(
  'absolute -bottom-6 text-center uppercase'
  // leadingNone
)
